import { paginationParams } from "@/utils/pagination";
import request from "@/utils/request";
import { cleanObjectFromUndefined } from "@/utils/utils";

export async function createEntityGroup(params) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups`, {
    method: "POST",
    data: params,
  });
  return result?.data;
}

export async function updateEntityGroup(id, name, isGroupReportsEnabled, concurrencyStamp) {
  const data = {
    name,
    isGroupReportsEnabled,
    concurrencyStamp,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups/${id}`, {
    method: "PUT",
    data,
  });
  return result?.data;
}

export async function deleteEntityGroup(id) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups/${id}`, {
    method: "DELETE",
  });
  return result?.data;
}

export async function addCompanyToEntityGroup(id, companyId, concurrencyStamp) {
  const data = {
    companyId,
    concurrencyStamp,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups/${id}/add-company`, {
    method: "PUT",
    data,
  });

  if (result?.data) {
    return result.data;
  }

  return Promise.resolve({ message: "error", result });
}

export async function removeDealerFromEntityGroup(companyId, entityGroupId, concurrencyStamp) {
  const data = {
    companyId,
    concurrencyStamp,
  };

  const result = await request(
    `${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups/${entityGroupId}/remove-company`,
    {
      method: "PUT",
      data,
    },
  );
  return result?.data;
}

export async function getAllEntitiesGroups({
  page = 1,
  pageSize = 10,
  filter = "",
  sorting = undefined,
  tagIds = undefined,
}) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);
  let Sorting;

  if (typeof sorting === "string" && sorting.indexOf(":") !== -1) {
    const [sortBy, sortOrder] = sorting.split(":");
    Sorting = `${sortBy} ${sortOrder}`;
  }

  const params = cleanObjectFromUndefined({
    SkipCount,
    MaxResultCount,
    FilterText: filter || undefined,
    Sorting,
    TagIds: tagIds,
  });

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function getEntityGroupDetails(groupId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups/${groupId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function fetchEntitiesList({ entityGroupId, page = 1, pageSize = 10 }) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    SkipCount,
    MaxResultCount,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company/by-group/${entityGroupId}`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function fetchAssociatedUsers(filterId, page = 1, pageSize = 10, filterText = "") {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    FilterId: filterId,
    SkipCount,
    MaxResultCount,
    FilterText: filterText || undefined,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users`, {
    method: "GET",
    params,
  });

  return result?.data;
}

export async function fetchAssociatedShippers(filterId, page = 1, pageSize = 10, filterText = "") {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    FilterId: filterId,
    SkipCount,
    MaxResultCount,
  };

  if (filterText) {
    params.FilterText = filterText;
  }

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/shippers`, {
    method: "GET",
    params,
  });

  return result?.data;
}
export async function addUserToCompany(referenceId, userId, type) {
  const data = {
    referenceId,
    userId,
    type,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users`, {
    method: "POST",
    data,
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.data;
}

export async function deleteUserFromEntityGroup(userId, reason) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/${userId}`, {
    method: "DELETE",
    params: { reason },
  });

  if ("error" in result) {
    throw new Error(result.error);
  }

  return result?.response?.ok;
}

export async function checkIfGroupExists(groupId) {
  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/company-groups/exist/${groupId}`, {
    method: "GET",
  });

  return result?.data;
}

export async function fetchAssociatedEntities(userId, associateUserType, page = 1, pageSize = 10) {
  const { SkipCount, MaxResultCount } = paginationParams(page, pageSize);

  const params = {
    UserId: userId,
    Type: associateUserType,
    SkipCount,
    MaxResultCount,
  };

  const result = await request(`${REACT_APP_API_BASE_URL_NEW}/api/core-service/associated-users/by-user-id`, {
    method: "GET",
    params,
  });

  if ("error" in result) {
    throw new Error(result?.error);
  }

  return result?.data;
}
